import React, { useMemo} from 'react'
import { Stack } from "@mui/material"
import { useLSContext } from "../Context/useLSContext"
import { ScoreBlock } from "./ScoreBlock"
import { useDataContext } from "../Context/useDataContext"

interface ScoringViewProps {
    stackRef: React.RefObject<HTMLDivElement | null>;
}

export const ScoringView = ({stackRef}: ScoringViewProps) => {
    const { factor, windowSize } = useLSContext();
    const { registrationData, eventData, groupScorer, scoreCode } = useDataContext();

    // Memoize reducedRegistrations to prevent recalculation on every render
    const reducedRegistrations = useMemo(() => {
        const deduplicated = registrationData?.reduce((acc: any, registration: any) => {
            if (!acc.some((item: any) => item.scoreCode === registration.scoreCode)) {
                acc.push(registration);
            }
            return acc;
        }, []) || [];
        
        // Sort to ensure current player (where scoreCode matches) appears first
        return deduplicated.sort((a: any, b: any) => {
            if (a.scoreCode === scoreCode) return -1;
            if (b.scoreCode === scoreCode) return 1;
            return 0;
        });
    }, [registrationData, scoreCode]);

    return (
        <Stack 
            ref={stackRef}
            direction={'column'} 
            sx={{ 
                height: `calc(100dvh - ${windowSize.appBarHeight + 148}px)`,
                alignItems: 'center',
                gap: factor * 0.75,
                width: 'inherit',
                marginTop: 0,
                paddingTop: 0,
                paddingBottom: (groupScorer || eventData?.scoreType?.toLowerCase() === 'opponent') ? '240px' : '90px',
                overflowY: 'auto',
                WebkitOverflowScrolling: 'touch',
                '&::-webkit-scrollbar': {
                    display: 'none'
                }

            }}>
            {reducedRegistrations.map((registration: any) => (
                <ScoreBlock key={registration.scoreCode} blockScoreCode={registration.scoreCode} />
            ))}
            
        </Stack>
    );
};

